import {
  Box,
  Card,
  CardContent,
  Typography,
  TextField,
  Button,
  useMediaQuery,
  useTheme,
} from "@mui/material";
import { Psychology } from "@mui/icons-material";
import { useNavigate } from "react-router-dom";
import { alpha } from "@mui/material/styles";

const AISummaryStep = ({
  profileData,
  handleInputChange,
  handleProfileSubmit,
}) => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));
  const navigate = useNavigate();

  const titleStyle = {
    color: "primary.main",
    fontWeight: "600",
    mb: 2,
  };


  const generateAIProfile = async () => {
    const accessToken = localStorage.getItem("access_token");

    if (!accessToken) {
      console.error("Access token not found in local storage.");
      return;
    }

    try {
      // 1. Perform the POST request first with the specified body
      const postResponse = await fetch("https://tdtlworld.com/dss-gatep-backend/api/resume-builder/", {
        method: "POST",
        headers: {
          "Content-Type": "application/json", // Ensures the server knows we're sending JSON
          Authorization: `Bearer ${accessToken}`,
        },
        // Add the body to the POST request
        body: JSON.stringify({
          generate_summary: true
        }),
      });

      if (!postResponse.ok) {
        throw new Error(`Network response for POST request was not ok: ${postResponse.statusText}`);
      }

      // 2. If the POST request is successful, then perform the GET request
      const getResponse = await fetch("https://tdtlworld.com/dss-gatep-backend/api/resume-builder/", {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${accessToken}`,
        },
      });

      if (!getResponse.ok) {
        throw new Error(`Network response for GET request was not ok: ${getResponse.statusText}`);
      }

      const data = await getResponse.json();
      if (data.generated_summary) {
        handleInputChange("generated_summary", data.generated_summary);
      }
    } catch (error) {
      console.error("There was a problem with the fetch operation:", error);
    }
  };

  // eslint-disable-next-line no-unused-vars
  const onSubmit = async () => {
    if (handleProfileSubmit) {
      const success = await handleProfileSubmit();
      if (success !== false) {
        navigate("/pages/talentdashboard");
      }
    } else {
      navigate("/pages/talentdashboard");
    }
  };

  return (
    <Box>
      <Typography variant="body2" color="primary.main" sx={{ mb: 3, fontWeight: 500 }}>
        Generate an AI-powered professional summary or write your own.
      </Typography>

      <Card
        elevation={0}
        sx={{
          bgcolor: "background.paper",
          borderRadius: "24px",
          border: theme => `1px solid ${alpha(theme.palette.primary.main, 0.1)}`,
          boxShadow: theme => `0 4px 20px ${alpha(theme.palette.common.black, 0.05)}`,
        }}
      >

        <CardContent sx={{ p: 3 }}>
          <Box
            display="flex"
            flexDirection={{ xs: "column", sm: "row" }}
            alignItems={{ xs: "flex-start", sm: "center" }}
            gap={2}
            mb={3}
          >
            <Psychology
              color="primary"
              sx={{ fontSize: { xs: 32, sm: 40 } }}
            />
            <Box>
              <Typography variant="h6" sx={titleStyle}>
                AI-Powered Professional Summary
              </Typography>
              <Typography
                variant="body2"
                color="text.secondary"
                sx={{ fontSize: { xs: "0.8rem", sm: "0.875rem" } }}
              >
                Generate a professional summary based on your profile data or
                write your own.
              </Typography>
            </Box>
          </Box>
          <TextField
            fullWidth
            multiline
            rows={isMobile ? 4 : 6}
            label="Professional Summary"
            value={profileData.summary}
            onChange={(e) => handleInputChange("summary", e.target.value)}
            size="small"
            variant="outlined"
            placeholder="Write a compelling professional summary that highlights your key skills, experience, and career objectives..."
            helperText="This summary will be prominently displayed on your profile. Make it count!"
          />
          <Button
            variant="contained"
            onClick={generateAIProfile}
            startIcon={<Psychology />}
            sx={{
              mb: 3,
              mt: 2,
              height: "56px",
              borderRadius: "12px",
              fontWeight: "bold",
              boxShadow: theme => `0 4px 14px ${alpha(theme.palette.primary.main, 0.3)}`,
            }}
            fullWidth={isMobile}
            size="medium"
          >
            Generate AI Summary
          </Button>

          <Box sx={{ mt: 2 }}>
            <TextField
              fullWidth
              multiline
              label="Generated Summary (Auto-filled)"
              value={profileData.generated_summary}
              onChange={(e) =>
                handleInputChange("generated_summary", e.target.value)
              }
              size="small"
              variant="outlined"
              InputProps={{ readOnly: true }}
              helperText="Hit the generate button to Enhance your Professional Summary."
            />
          </Box>
          {/* <Button
            variant="contained"
            color="primary"
            sx={{ mt: 3 }}
            fullWidth={isMobile}
            onClick={onSubmit}
          >
            Submit Profile
          </Button> */}
        </CardContent>
      </Card>
    </Box>
  );
};

export default AISummaryStep;
